import { Component, OnInit } from '@angular/core';
import { RouterService } from '../../../services/router/router.service';
import { APP_ROUTES } from '../../../utils/route.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { SR_INIT_URL_EXPIRED, SR_STATUS_URL_EXPIRED, VIVR_PAYMENT_ALREADY_DONE, VIVR_PAYMENT_URL_EXPIRED, VIVR_QUERY_PARAM_KEY } from '../../../utils/constants';
import { Scenario } from './session-timeout.interface';
import { trackByIndex } from '../../../utils/helper';

@Component({
    selector: 'app-session-timeout',
    templateUrl: './session-timeout.component.html',
    styleUrl: './session-timeout.component.scss'
})
export class SessionTimeoutComponent implements OnInit {
    vivrSessionParam: string | null = null;
    scenarios: { [key: string]: Scenario } = {
        timeout : {
            icon: 'link-expired-icon',
            title: 'Oops!<br/>Your session timed out.',
            content: [
                { text: 'To keep your information safe, your session timed out after a period of inactivity.' },
                { text: 'No worries - simply log back in to', loginLink: true },
            ]
        },
        expired: {
            icon: 'link-expired-icon',
            title: 'Oops!<br/>This link has expired',
            content: [
                { text: 'For your security, links are valid for 1 hour only.' },
                { text: 'To check your service status, please', loginLink: true }
            ]
        },

        statusLinkExpired: {
            icon: 'link-expired-icon',
            title: 'Oops!<br/>This link has expired',
            content: [
                { text: 'Links are valid for 24 hours.' },
                { text: 'To check your service status, please', loginLink: true }
            ]
        },
        paymentUrlExpired: {
            icon: 'link-expired-icon',
            title: 'Oops!<br/>This link has expired',
            content: [
                { text: 'For your security, payment links are valid for 24 hours.' },
                { text: "If you have already paid, you're all set - no further action is needed. To make a payment, please", loginLink: true }
            ]
        },
        alreadyUsed: {
            icon: 'pi pi-info-circle',
            title: 'Payment in progress',
            content: [
                { text: 'To check the payment status, please', loginLink: true }
            ]
        }
    };
    currentScenario: Scenario | null = this.scenarios['timeout'];

    trackByIndex = trackByIndex;
    constructor(
        private route: ActivatedRoute,
        private routerService: RouterService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.vivrSessionParam = this.route.snapshot.queryParamMap.get(VIVR_QUERY_PARAM_KEY);
        if (this.vivrSessionParam) {
            this.currentScenario = this.setCurrentScenario(this.vivrSessionParam);
        }
    }

    setCurrentScenario(vivrSessionParam: string | null): Scenario | null{
        switch (vivrSessionParam) {
            case VIVR_PAYMENT_ALREADY_DONE:
                 return this.scenarios['alreadyUsed'];
            case VIVR_PAYMENT_URL_EXPIRED:
                return this.scenarios['paymentUrlExpired'];
            case SR_INIT_URL_EXPIRED:
                return this.scenarios['expired'];
            case SR_STATUS_URL_EXPIRED:
                return this.scenarios['statusLinkExpired'];
            default:
                this.router.navigate(['/404']); // If wrong param route to 404 page
                return null;
        }
    }

    navigateToLogin(): void {
        this.routerService.goto(APP_ROUTES.LOGIN);
    }

    
}
